module.exports = __webpack_public_path__ + "static/img/3.ec3e101.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/14/zh/3.png
// module id = uRRx
// module chunks = 0